<div class="footer">
  <div class="footer_box">
    <div class="footer_box_top">
      <div class="footer_box_top_left">
        <img
          class="footer_box_top_left_logo"
          [src]="
            footerdata.footer_logo
              ? baseurl + footerdata.footer_logo
              : '../../../assets/img/logo.png'
          "
        />
        <div class="footer_box_top_left_info text_style_1">
          <p
            [innerHTML]="
              footerdata.description ||
              'ChemRobotics™ Business, Scientific, & Innovation Intelligence for Generic and Discovery Agrochem, Pharmaceutical API & Specialty Chemical Industry including Battery Chemicals, Dyes, and LED Chemical etc.'
            "
          ></p>
        </div>
      </div>
      <div class="footer_box_top_center">
        <p class="text_style_2">Quick Links</p>
        <ul class="footer_box_top_center_list text_style_1">
          <li
            class="footer_box_top_center_list_item cursor-pointer"
            (click)="openInNewTab(appLinks.home)"
          >
            Home
          </li>
          <li
            class="footer_box_top_center_list_item cursor-pointer"
            (click)="openInNewTab(appLinks.aboutUs)"
          >
            About Us
          </li>
          <li
            class="footer_box_top_center_list_item cursor-pointer"
            (click)="openInNewTab(appLinks.clients)"
          >
            Clients
          </li>
          <li
            class="footer_box_top_center_list_item cursor-pointer"
            (click)="openInNewTab(appLinks.career)"
          >
            Career
          </li>
          <li
            class="footer_box_top_center_list_item cursor-pointer"
            (click)="openInNewTab(appLinks.contactUs)"
          >
            Contact Us
          </li>
          <li
            class="footer_box_top_center_list_item cursor-pointer"
            (click)="openInNewTab(appLinks.Ethics)"
          >
            Code of Ethics
          </li>
        </ul>
      </div>

      <div class="footer_box_top_center1">
        <p class="text_style_2">Quick Links1</p>
        <div class="footer_box_top_center1_list text_style_1">
          <div class="footer_box_top_center1_list_box">
            <div
              class="footer_box_top_center1_list_box_item cursor-pointer"
              (click)="openInNewTab(appLinks.home)"
            >
              <div>&ndash;</div>
              <div>Home</div>
            </div>
          </div>
          <div class="footer_box_top_center1_list_box">
            <div
              class="footer_box_top_center1_list_box_item cursor-pointer"
              (click)="openInNewTab(appLinks.aboutUs)"
            >
              <div>&ndash;</div>
              <div>About Us</div>
            </div>
          </div>
          <div class="footer_box_top_center1_list_box">
            <div
              class="footer_box_top_center1_list_box_item cursor-pointer"
              (click)="openInNewTab(appLinks.clients)"
            >
              <div>&ndash;</div>
              <div>Clients</div>
            </div>
          </div>
          <div
            class="footer_box_top_center1_list_box"
            (click)="openInNewTab(appLinks.career)"
          >
            <div class="footer_box_top_center1_list_box_item cursor-pointer">
              <div>&ndash;</div>
              <div>Career</div>
            </div>
          </div>
          <div
            class="footer_box_top_center1_list_box cursor-pointer"
            (click)="openInNewTab(appLinks.contactUs)"
          >
            <div class="footer_box_top_center1_list_box_item cursor-pointer">
              <div>&ndash;</div>
              <a>Contact Us</a>
            </div>
          </div>

          <div class="footer_box_top_center1_list_box cursor-pointer">
            <div class="footer_box_top_center1_list_box_item cursor-pointer">
              <div>&ndash;</div>
              <a>Code of Ethics</a>
            </div>
          </div>
        </div>
      </div>
      <div class="footer_box_top_right">
        <p class="text_style_2">Contact Us</p>
        <div class="footer_box_top_right_items">
          <div>
            <img src="../../../assets/icons/pincode_icon.png" />
          </div>
          <div>
            <p class="text_style_1">
              {{
                footerdata.address
                  ? footerdata.address
                  : "ChemRobotics Private Limited SITE C UPSIDC SURAJPUR, GREATER NOIDA 201311, INDIA"
              }}
            </p>
          </div>
          <div>
            <img src="../../../assets/icons/phone_icon.png" />
          </div>
          <div>
            <p class="text_style_1">
              {{
                footerdata.mobile_number
                  ? footerdata.mobile_number
                  : "+91 6266117944"
              }}
            </p>
          </div>
          <div>
            <img src="../../../assets/icons/email_icon.png" />
          </div>
          <div>
            <p class="text_style_1">
              {{
                footerdata.email ? footerdata.email : "support@chemrobotics.com"
              }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col md-4">
        <div>
          <a
            href="https://wa.me/916266117944"
            target="_blank"
            class="text_decoration_none cursor-pointer"
          >
            <div style="display: flex; align-items: center; margin-top: 10px">
              <img
                src="../../../assets/icons/whatsapp_icon.png"
                alt="WhatsApp Icon"
                width="50px"
                height="50px"
              />
              <span style="margin-left: 5px" class="text_style_1"
                >Chat With Us</span
              >
            </div>
          </a>
        </div>
      </div>
      <div class="col md-4">
        <div class="dis-flex-2">
          <a
            href="https://chat.whatsapp.com/HQ4vy7F2g1AKuGXOqk7CkQ"
            target="_blank"
            class="text_decoration_none cursor-pointer"
          >
            <div style="display: flex; align-items: center; margin-top: 10px">
              <img
                src="../../../assets/icons/whatsapp_icon.png"
                alt="WhatsApp Icon"
                width="50px"
                height="50px"
              />
              <span style="margin-left: 5px" class="text_style_1"
                >Subscribe for Latest News & Update</span
              >
            </div>
          </a>
        </div>
      </div>
      <div class="col md-4">
        <div style="display: flex; justify-content: end">
          <div style="display: flex; align-items: right; margin-top: 25px">
            <span style="margin-left: 5px" class="text_style_1"
              >View page in full screen -
              <a
                href="https://www.chemrobotics.com/registration"
                class="text_blue_17 cursor-pointer"
                target="_blank"
                style="text-decoration: none"
                >Sign Up</a
              >
              &nbsp;|&nbsp;
              <a
                href="https://www.chemrobotics.com/demo_request"
                class="text_blue_17 cursor-pointer"
                target="_blank"
                style="text-decoration: none"
                >Demo Request</a
              ></span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="footer_box_bottom">
      <div class="footer_box_bottom_text text_style_3">
        <p class="footer_box_bottom_text_item1">
          {{
            footerdata.copyright
              ? footerdata.copyright
              : "ChemRobotics Pvt. Ltd. © 2024, All Rights Reserved"
          }}
        </p>
        <p class="footer_box_bottom_text_item2 text-center">
          <span>Terms of Use</span>&nbsp;and&nbsp;
          <span>Privacy Policy</span>
        </p>
        <p class="footer_box_bottom_text_item3 text-end">
          <span>Follow us on</span>
          <a
            class="footer_box_bottom_text_item3_icon cursor-pointer"
            [href]="
              footerdata.facebook_URL
                ? footerdata.facebook_URL
                : 'https://www.facebook.com/ChemRobotics'
            "
            target="_blank"
          >
            <img src="../../../assets/icons/facebook.png" />
          </a>
          <a
            class="footer_box_bottom_text_item3_icon cursor-pointer"
            [href]="
              footerdata.linkdin_URL
                ? footerdata.linkdin_URL
                : 'https://www.linkedin.com/company/chemrobotics/'
            "
            target="_blank"
          >
            <img src="../../../assets/icons/linkedin.png" />
          </a>
          <a
            class="footer_box_bottom_text_item3_icon cursor-pointer"
            [href]="
              footerdata.youtube_URL
                ? footerdata.youtube_URL
                : 'https://www.youtube.com/channel/UCl21pDcr00u_asN6gCJ6hfQ'
            "
            target="_blank"
          >
            <img src="../../../assets/icons/youtube.png" />
          </a>
          <a
            class="footer_box_bottom_text_item3_icon cursor-pointer"
            [href]="
              footerdata.instagram_URL
                ? footerdata.instagram_URL
                : 'https://www.instagram.com/chemrobotics/'
            "
            target="_blank"
          >
            <img src="../../../assets/icons/instagram.png" />
          </a>
        </p>
      </div>
      <div class="text_align-right">
        <span class="color_red weight_500 font_13"
          >For better experience, please use ‘Google Chrome' browser</span
        >
      </div>
    </div>
  </div>
</div>
